'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import SvgFireFill from '@common/icon/SvgFireFill';
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { chunk } from 'es-toolkit';
import { useInView } from 'react-intersection-observer';
import { UnauthQueryOptions } from '@/api';
import { BREAKPOINTS } from '@/constants';
import { useAutoplayOnInView } from '@/hooks/useAutoplayOnInView';
import { LiveDonationItem } from './LiveDonationItem';
const CHUNK_SIZE = 3;
const BOX_CLASS_NAME = cn('w-full rounded-xxlarge border border-O-300 bg-Gray-white px-32 py-28', 'mobile-tablet:rounded-xlarge mobile-tablet:p-16');
//* PC는 세로 축이라 뷰포트 높이가 고정돼야 하고, 모바일은 가로 축이라 묶음 높이를 따른다
const VIEWPORT_CLASS_NAME = 'h-140 overflow-hidden mobile-tablet:h-auto';
const CHUNK_CLASS_NAME = cn('grid grid-cols-3 items-center gap-x-40', 'mobile-tablet:flex mobile-tablet:h-full mobile-tablet:flex-col mobile-tablet:items-stretch mobile-tablet:gap-16');
export const LiveDonationSection = t0 => {
  const $ = _c(41);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 0.3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    ref: inViewRef,
    inView
  } = useInView(t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      loop: true,
      axis: "y",
      align: "start",
      breakpoints: {
        [BREAKPOINTS.MOBILE_TABLET]: {
          axis: "x"
        }
      }
    };
    t3 = [Autoplay({
      delay: 3000,
      stopOnInteraction: false
    })];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t2, t3);
  useAutoplayOnInView(emblaApi, inView);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home-love/main/recent-gift-products"](),
      staleTime: 30000,
      refetchOnWindowFocus: true,
      select: _temp
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    data: t5,
    isLoading,
    isError
  } = useQuery(t4);
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== className || $[5] !== emblaRef || $[6] !== inViewRef || $[7] !== isError || $[8] !== isLoading || $[9] !== t5) {
    t14 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const recentGiftProductList = t5 === undefined ? [] : t5;
      if (isError || !isLoading && recentGiftProductList.length === 0) {
        t14 = null;
        break bb0;
      }
      if (isLoading) {
        let t15;
        if ($[19] !== className) {
          t15 = <LiveDonationSectionSkeleton className={className} />;
          $[19] = className;
          $[20] = t15;
        } else {
          t15 = $[20];
        }
        t14 = t15;
        break bb0;
      }
      const hasNextChunk = recentGiftProductList.length > CHUNK_SIZE;
      t11 = inViewRef;
      if ($[21] !== className) {
        t12 = cn(SECTION_CLASS_NAME, className);
        $[21] = className;
        $[22] = t12;
      } else {
        t12 = $[22];
      }
      if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = <LiveDonationHeader />;
        $[23] = t13;
      } else {
        t13 = $[23];
      }
      t10 = BOX_CLASS_NAME;
      t8 = emblaRef;
      t9 = VIEWPORT_CLASS_NAME;
      t6 = "flex h-full flex-col mobile-tablet:flex-row";
      let t15;
      if ($[24] !== hasNextChunk) {
        t15 = (items, chunkIndex) => <ul key={chunkIndex} className={cn("min-h-0 flex-[0_0_100%] mobile-tablet:min-w-0", {
          "mb-12 mobile-tablet:mb-0 mobile-tablet:mr-12 mobile-tablet:max-w-[88%] mobile-tablet:flex-[0_0_auto]": hasNextChunk
        }, CHUNK_CLASS_NAME)}>{items.map(item => <LiveDonationItem key={`${item.productNumber}-${item.createAt}`} item={item} priority={chunkIndex === 0} />)}</ul>;
        $[24] = hasNextChunk;
        $[25] = t15;
      } else {
        t15 = $[25];
      }
      t7 = chunk(recentGiftProductList, CHUNK_SIZE).map(t15);
    }
    $[4] = className;
    $[5] = emblaRef;
    $[6] = inViewRef;
    $[7] = isError;
    $[8] = isLoading;
    $[9] = t5;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  if (t14 !== Symbol.for("react.early_return_sentinel")) {
    return t14;
  }
  let t15;
  if ($[26] !== t6 || $[27] !== t7) {
    t15 = <div className={t6}>{t7}</div>;
    $[26] = t6;
    $[27] = t7;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t8 || $[31] !== t9) {
    t16 = <div ref={t8} className={t9}>{t15}</div>;
    $[29] = t15;
    $[30] = t8;
    $[31] = t9;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t10 || $[34] !== t16) {
    t17 = <div className={t10}>{t16}</div>;
    $[33] = t10;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t11 || $[37] !== t12 || $[38] !== t13 || $[39] !== t17) {
    t18 = <section ref={t11} className={t12}>{t13}{t17}</section>;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
};
export const LiveDonationSectionSkeleton = t0 => {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(SECTION_CLASS_NAME, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LiveDonationHeader />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={BOX_CLASS_NAME}><ul className={cn(VIEWPORT_CLASS_NAME, CHUNK_CLASS_NAME)}>{Array.from({
          length: CHUNK_SIZE
        }, _temp2)}</ul></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <section aria-hidden="true" className={t1}>{t2}{t3}</section>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
const SECTION_CLASS_NAME = cn('flex flex-col items-center gap-16 px-40 content-container', 'mobile-tablet:gap-12 mobile-tablet:px-20');
const LiveDonationHeader = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <header className="flex items-center"><h2 className="flex items-center gap-2"><SvgFireFill aria-hidden="true" className="size-36 text-O-300 mobile-tablet:size-24" /><span className="bg-gradient-to-r from-O-500 to-R-500 bg-clip-text font-800 text-transparent typo-h4 mobile-tablet:typo-h7">전국 실시간 기부중</span></h2></header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(data) {
  return data.context?.contents ?? [];
}
function _temp2(_, index) {
  return <li key={index} className="flex items-center gap-20 mobile-tablet:h-96 mobile-tablet:gap-12"><Skeleton className="size-140 shrink-0 rounded-xlarge mobile-tablet:size-76 mobile-tablet:rounded-small" /><div className="flex flex-1 flex-col gap-4"><Skeleton typo="body4" className="w-1/3 rounded-xxsmall" /><Skeleton typo="body3" className="w-full rounded-xxsmall" /><Skeleton typo="body3" className="w-2/3 rounded-xxsmall" /></div></li>;
}